var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1044,
    height: 397,
    viewBox: "0 0 1044 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M551.485 126.439V128.808C551.485 128.808 545.135 128.808 537.194 128.808C529.253 128.808 526.604 132.69 526.604 132.69H517.24C517.24 132.69 514.591 128.808 506.649 128.808C498.712 128.808 492.358 128.808 492.358 128.808V126.439H500.3L505.184 123.219C505.184 123.219 515.2 123.549 516.627 121.032C518.054 118.516 518.867 113.634 518.867 113.634H524.978C524.978 113.634 525.791 118.516 527.213 121.032C528.64 123.549 538.66 123.219 538.66 123.219L543.544 126.439H551.485Z",
    fill: "#324B85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M551.485 126.439V128.808C551.485 128.808 545.135 128.808 537.194 128.808C529.253 128.808 526.604 132.69 526.604 132.69H521.924V113.634H524.977C524.977 113.634 525.791 118.515 527.213 121.032C528.639 123.548 538.659 123.218 538.659 123.218L543.543 126.439L551.485 126.439Z",
    fill: "#215681"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M528.439 182.156H515.404C519.475 163.027 519.071 132.69 519.071 132.69H524.773C524.773 132.69 524.364 163.027 528.439 182.156Z",
    fill: "#142216"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M520.502 182.156C522.981 163.027 522.733 132.69 522.733 132.69H524.773C524.773 132.69 524.364 163.026 528.439 182.156H520.502Z",
    fill: "#215681"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M537.523 188.48H506.321C506.321 188.48 507.261 182.155 515.406 182.155H528.438C536.583 182.155 537.523 188.48 537.523 188.48Z",
    fill: "#EA9B1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M521.922 116.325C523.878 116.325 525.463 114.74 525.463 112.786C525.463 110.832 523.878 109.247 521.922 109.247C519.967 109.247 518.382 110.832 518.382 112.786C518.382 114.74 519.967 116.325 521.922 116.325Z",
    fill: "#EA9B1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M520.482 112.786C520.482 113.581 521.127 114.226 521.923 114.226C522.718 114.226 523.364 113.581 523.364 112.786C523.364 111.991 522.718 111.346 521.923 111.346C521.126 111.347 520.482 111.992 520.482 112.786Z",
    fill: "#CC6017"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M516.788 126.165C516.788 128.999 519.087 131.296 521.922 131.296C524.757 131.296 527.056 128.999 527.056 126.165C527.056 123.331 524.757 121.034 521.922 121.034C519.087 121.034 516.788 123.331 516.788 126.165Z",
    fill: "#EA9B1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M519.834 126.165C519.834 127.318 520.769 128.253 521.923 128.253C523.077 128.253 524.012 127.318 524.012 126.165C524.012 125.012 523.077 124.077 521.923 124.077C520.769 124.078 519.834 125.012 519.834 126.165Z",
    fill: "#CC6017"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M503.338 160.087L491.568 127.605L479.797 160.087",
    stroke: "#0F3749",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M495.108 127.605C495.108 129.559 493.523 131.143 491.568 131.143C489.612 131.143 488.027 129.558 488.027 127.605C488.027 125.65 489.612 124.066 491.568 124.066C493.523 124.066 495.108 125.65 495.108 127.605Z",
    fill: "#EA9B1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M493.009 127.605C493.009 128.4 492.363 129.044 491.568 129.044C490.772 129.044 490.127 128.4 490.127 127.605C490.127 126.81 490.772 126.165 491.568 126.165C492.363 126.165 493.009 126.81 493.009 127.605Z",
    fill: "#CC6017"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M503.338 159.596C503.338 160.803 503.294 169.484 491.568 169.484C479.843 169.484 479.798 160.802 479.798 159.596C479.798 158.391 485.068 157.413 491.568 157.413C498.069 157.413 503.338 158.39 503.338 159.596Z",
    fill: "#324B85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M491.568 161.78C498.069 161.78 503.338 160.802 503.338 159.596C503.338 158.391 498.069 157.413 491.568 157.413C485.068 157.413 479.798 158.391 479.798 159.596C479.798 160.802 485.068 161.78 491.568 161.78Z",
    fill: "#59A1C9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M491.568 161.279C497.305 161.279 501.956 160.525 501.956 159.597C501.956 158.668 497.305 157.914 491.568 157.914C485.831 157.914 481.181 158.668 481.181 159.597C481.181 160.525 485.831 161.279 491.568 161.279Z",
    fill: "#215681"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M564.046 160.087L552.275 127.605L540.505 160.087",
    stroke: "#0F3749",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M555.816 127.605C555.816 129.559 554.231 131.143 552.275 131.143C550.32 131.143 548.735 129.558 548.735 127.605C548.735 125.65 550.32 124.066 552.275 124.066C554.231 124.066 555.816 125.65 555.816 127.605Z",
    fill: "#EA9B1C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M553.716 127.605C553.716 128.4 553.071 129.044 552.275 129.044C551.479 129.044 550.835 128.4 550.835 127.605C550.835 126.81 551.48 126.165 552.275 126.165C553.071 126.165 553.716 126.81 553.716 127.605Z",
    fill: "#CC6017"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M564.046 159.596C564.046 160.803 564.002 169.484 552.275 169.484C540.549 169.484 540.505 160.802 540.505 159.596C540.505 158.391 545.775 157.413 552.275 157.413C558.776 157.412 564.046 158.39 564.046 159.596Z",
    fill: "#324B85"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M552.275 161.78C558.776 161.78 564.046 160.802 564.046 159.596C564.046 158.391 558.776 157.413 552.275 157.413C545.775 157.413 540.505 158.391 540.505 159.596C540.505 160.802 545.775 161.78 552.275 161.78Z",
    fill: "#59A1C9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M552.275 161.279C558.012 161.279 562.663 160.525 562.663 159.597C562.663 158.668 558.012 157.914 552.275 157.914C546.538 157.914 541.888 158.668 541.888 159.597C541.888 160.525 546.538 161.279 552.275 161.279Z",
    fill: "#215681"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M479.385 160.454C480.134 160.454 480.741 159.847 480.741 159.099C480.741 158.35 480.134 157.744 479.385 157.744C478.636 157.744 478.029 158.35 478.029 159.099C478.029 159.847 478.636 160.454 479.385 160.454Z",
    fill: "#EA9B1C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M504.063 160.454C504.812 160.454 505.419 159.847 505.419 159.099C505.419 158.35 504.812 157.744 504.063 157.744C503.315 157.744 502.708 158.35 502.708 159.099C502.708 159.847 503.315 160.454 504.063 160.454Z",
    fill: "#EA9B1C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M539.936 160.454C540.685 160.454 541.292 159.847 541.292 159.099C541.292 158.35 540.685 157.744 539.936 157.744C539.187 157.744 538.58 158.35 538.58 159.099C538.58 159.847 539.187 160.454 539.936 160.454Z",
    fill: "#EA9B1C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M564.614 160.454C565.363 160.454 565.97 159.847 565.97 159.099C565.97 158.35 565.363 157.744 564.614 157.744C563.865 157.744 563.258 158.35 563.258 159.099C563.258 159.847 563.865 160.454 564.614 160.454Z",
    fill: "#EA9B1C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.63 391.105C1046.02 391.069 1038.61 305.635 1037.53 298.08C1032.83 265.003 1024.84 232.482 1012.99 201.846C990.986 144.969 957.044 100.133 903.877 81.0258C858.942 64.8781 808.99 72.3589 767.242 96.4089C727.739 119.166 697.818 157.388 661.636 185.739C639.648 202.968 613.012 216.659 583.818 225.335C532.734 240.517 474.308 240.211 423.493 224.494C340.968 198.967 273.182 131.707 175.746 148.017C171.589 148.714 167.472 149.545 163.409 150.517C97.7516 166.215 69.4661 209.686 45.9383 255.711C23.7882 299.041 9.60254 345.081 0.489746 391.106C0.489746 391.106 1042.61 391.105 1042.63 391.105Z",
    fill: "#FFD3CA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M386.702 154.03H383.916V177.577H386.702V154.03Z",
    fill: "#D77C2F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M362.148 154.03H359.362V177.577H362.148V154.03Z",
    fill: "#D77C2F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M370.334 154.03H367.547V177.577H370.334V154.03Z",
    fill: "#D77C2F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M378.518 154.03H375.731V177.577H378.518V154.03Z",
    fill: "#D77C2F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M394.886 154.03H392.1V177.577H394.886V154.03Z",
    fill: "#D77C2F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M403.072 154.03H400.286V177.577H403.072V154.03Z",
    fill: "#D77C2F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M411.256 154.03H408.47V177.577H411.256V154.03Z",
    fill: "#D77C2F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M413.153 152.273H357.466V155.787H413.153V152.273Z",
    fill: "#B14F18"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M414.4 147.915H356.217V153.567H414.4V147.915Z",
    fill: "#D77C2F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M413.153 177.577H357.466V183.195H413.153V177.577Z",
    fill: "#B14F18"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M416.944 181.091H353.674V186.362H416.944V181.091Z",
    fill: "#D77C2F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M420.509 184.605H350.109V188.119H420.509V184.605Z",
    fill: "#B14F18"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.4 147.842L387.29 131.735H383.328L356.217 147.842V150.195H414.4V147.842Z",
    fill: "#B14F18"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.309 130.046L354.985 148.062V150.516L385.309 132.5L415.632 150.516V148.062L385.309 130.046Z",
    fill: "#D77C2F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.668 155.787H362.841C363.286 155.787 363.65 156.15 363.65 156.595V156.596C363.65 157.041 363.286 157.405 362.841 157.405H358.668C358.224 157.405 357.86 157.041 357.86 156.596V156.595C357.86 156.15 358.224 155.787 358.668 155.787Z",
    fill: "#D77C2F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M386.702 157.404H383.916V157.76H386.702V157.404Z",
    fill: "#B06042"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M362.148 157.404H359.362V157.76H362.148V157.404Z",
    fill: "#B06042"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M370.334 157.404H367.547V157.76H370.334V157.404Z",
    fill: "#B06042"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M378.518 157.404H375.731V157.76H378.518V157.404Z",
    fill: "#B06042"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M394.887 157.404H392.1V157.76H394.887V157.404Z",
    fill: "#B06042"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M403.072 157.404H400.286V157.76H403.072V157.404Z",
    fill: "#B06042"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M411.256 157.404H408.47V157.76H411.256V157.404Z",
    fill: "#B06042"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.669 157.07C358.93 157.07 359.144 156.857 359.144 156.595C359.144 156.333 358.93 156.12 358.669 156.12C358.407 156.12 358.193 156.333 358.193 156.595C358.194 156.857 358.407 157.07 358.669 157.07Z",
    fill: "#B06042"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.841 157.07C363.103 157.07 363.316 156.857 363.316 156.595C363.316 156.333 363.103 156.12 362.841 156.12C362.579 156.12 362.366 156.333 362.366 156.595C362.366 156.857 362.579 157.07 362.841 157.07Z",
    fill: "#B06042"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.853 155.787H371.026C371.47 155.787 371.834 156.15 371.834 156.595V156.596C371.834 157.041 371.47 157.405 371.026 157.405H366.853C366.408 157.405 366.044 157.041 366.044 156.596V156.595C366.044 156.15 366.408 155.787 366.853 155.787Z",
    fill: "#D77C2F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.854 157.07C367.116 157.07 367.329 156.857 367.329 156.595C367.329 156.333 367.116 156.12 366.854 156.12C366.592 156.12 366.379 156.333 366.379 156.595C366.379 156.857 366.592 157.07 366.854 157.07Z",
    fill: "#B06042"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.025 157.07C371.287 157.07 371.501 156.857 371.501 156.595C371.501 156.333 371.287 156.12 371.025 156.12C370.764 156.12 370.551 156.333 370.551 156.595C370.55 156.857 370.764 157.07 371.025 157.07Z",
    fill: "#B06042"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.039 155.787H379.211C379.656 155.787 380.02 156.15 380.02 156.595V156.596C380.02 157.041 379.656 157.405 379.211 157.405H375.039C374.594 157.405 374.23 157.041 374.23 156.596V156.595C374.229 156.15 374.594 155.787 375.039 155.787Z",
    fill: "#D77C2F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.039 157.07C375.3 157.07 375.514 156.857 375.514 156.595C375.514 156.333 375.3 156.12 375.039 156.12C374.777 156.12 374.563 156.333 374.563 156.595C374.563 156.857 374.777 157.07 375.039 157.07Z",
    fill: "#B06042"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.21 157.07C379.472 157.07 379.685 156.857 379.685 156.595C379.685 156.333 379.472 156.12 379.21 156.12C378.948 156.12 378.735 156.333 378.735 156.595C378.735 156.857 378.948 157.07 379.21 157.07Z",
    fill: "#B06042"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.223 155.787H387.396C387.841 155.787 388.204 156.15 388.204 156.595V156.596C388.204 157.041 387.841 157.405 387.396 157.405H383.223C382.778 157.405 382.415 157.041 382.415 156.596V156.595C382.414 156.15 382.777 155.787 383.223 155.787Z",
    fill: "#D77C2F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.223 157.07C383.484 157.07 383.698 156.857 383.698 156.595C383.698 156.333 383.484 156.12 383.223 156.12C382.961 156.12 382.748 156.333 382.748 156.595C382.748 156.857 382.961 157.07 383.223 157.07Z",
    fill: "#B06042"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.395 157.07C387.656 157.07 387.87 156.857 387.87 156.595C387.87 156.333 387.656 156.12 387.395 156.12C387.133 156.12 386.919 156.333 386.919 156.595C386.919 156.857 387.133 157.07 387.395 157.07Z",
    fill: "#B06042"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.408 155.787H395.58C396.025 155.787 396.39 156.15 396.39 156.595V156.596C396.39 157.041 396.026 157.405 395.58 157.405H391.408C390.963 157.405 390.599 157.041 390.599 156.596V156.595C390.598 156.15 390.963 155.787 391.408 155.787Z",
    fill: "#D77C2F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.408 157.07C391.669 157.07 391.883 156.857 391.883 156.595C391.883 156.333 391.669 156.12 391.408 156.12C391.146 156.12 390.933 156.333 390.933 156.595C390.933 156.857 391.146 157.07 391.408 157.07Z",
    fill: "#B06042"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.58 157.07C395.842 157.07 396.055 156.857 396.055 156.595C396.055 156.333 395.842 156.12 395.58 156.12C395.318 156.12 395.105 156.333 395.105 156.595C395.105 156.857 395.318 157.07 395.58 157.07Z",
    fill: "#B06042"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.592 155.787H403.764C404.209 155.787 404.574 156.15 404.574 156.595V156.596C404.574 157.041 404.21 157.405 403.764 157.405H399.592C399.147 157.405 398.783 157.041 398.783 156.596V156.595C398.783 156.15 399.147 155.787 399.592 155.787Z",
    fill: "#D77C2F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.592 157.07C399.854 157.07 400.067 156.857 400.067 156.595C400.067 156.333 399.854 156.12 399.592 156.12C399.33 156.12 399.117 156.333 399.117 156.595C399.118 156.857 399.33 157.07 399.592 157.07Z",
    fill: "#B06042"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.764 157.07C404.026 157.07 404.239 156.857 404.239 156.595C404.239 156.333 404.026 156.12 403.764 156.12C403.503 156.12 403.289 156.333 403.289 156.595C403.289 156.857 403.503 157.07 403.764 157.07Z",
    fill: "#B06042"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.776 155.787H411.949C412.394 155.787 412.758 156.15 412.758 156.595V156.596C412.758 157.041 412.394 157.405 411.949 157.405H407.776C407.331 157.405 406.968 157.041 406.968 156.596V156.595C406.968 156.15 407.331 155.787 407.776 155.787Z",
    fill: "#D77C2F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.777 157.07C408.039 157.07 408.253 156.857 408.253 156.595C408.253 156.333 408.039 156.12 407.777 156.12C407.516 156.12 407.302 156.333 407.302 156.595C407.302 156.857 407.516 157.07 407.777 157.07Z",
    fill: "#B06042"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.949 157.07C412.21 157.07 412.424 156.857 412.424 156.595C412.424 156.333 412.21 156.12 411.949 156.12C411.687 156.12 411.474 156.333 411.474 156.595C411.474 156.857 411.687 157.07 411.949 157.07Z",
    fill: "#B06042"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M362.858 176.436H358.652V177.578H362.858V176.436Z",
    fill: "#D77C2F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M371.042 176.436H366.836V177.578H371.042V176.436Z",
    fill: "#D77C2F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M379.228 176.436H375.021V177.578H379.228V176.436Z",
    fill: "#D77C2F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M387.412 176.436H383.205V177.578H387.412V176.436Z",
    fill: "#D77C2F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M395.596 176.436H391.389V177.578H395.596V176.436Z",
    fill: "#D77C2F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M403.782 176.436H399.575V177.578H403.782V176.436Z",
    fill: "#D77C2F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M411.966 176.436H407.759V177.578H411.966V176.436Z",
    fill: "#D77C2F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M359.779 176.483H359.068V177.434H359.779V176.483Z",
    fill: "#B14F18"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M367.963 176.483H367.253V177.434H367.963V176.483Z",
    fill: "#B14F18"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M376.028 176.483H375.317V177.434H376.028V176.483Z",
    fill: "#B14F18"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M384.212 176.483H383.501V177.434H384.212V176.483Z",
    fill: "#B14F18"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M392.397 176.483H391.687V177.434H392.397V176.483Z",
    fill: "#B14F18"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M400.582 176.483H399.872V177.434H400.582V176.483Z",
    fill: "#B14F18"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M408.767 176.483H408.056V177.434H408.767V176.483Z",
    fill: "#B14F18"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M410.69 149.051L359.932 148.691L385.311 133.613L385.423 133.681L410.69 149.051ZM361.506 148.265L409.108 148.603L385.309 134.124L361.506 148.265Z",
    fill: "#F7EEDF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M360.034 158.079V176.436",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M368.319 158.079V176.436",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M376.604 158.079V176.436",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M384.723 158.079V176.436",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M392.942 158.079V176.436",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M401.028 158.079V176.436",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M409.312 158.079V176.436",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M747.597 187.51H296.402V202.81H747.597V187.51Z",
    fill: "#67554C"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M732.071 202.81H311.928V392.746H732.071V202.81Z",
    fill: "#67554C"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M732.071 202.81H311.928L312.702 224.931L732.108 243.812L732.071 202.81Z",
    fill: "#563E31"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M351.809 309.181H732.041",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M351.809 329.738H732.041",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M351.809 350.295H732.041",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M351.809 370.851H732.041",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M159.41 313.411L145.512 391.773H153.87L174.644 313.411H159.41Z",
    fill: "#D97C2F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M172.658 320.905L156.523 329.686L159.41 313.411H174.643L172.658 320.905Z",
    fill: "#B14F18"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M188.541 313.411L174.644 391.773H183.002L203.775 313.411H188.541Z",
    fill: "#D97C2F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M201.788 320.905L185.655 329.686L188.54 313.411H203.775L201.788 320.905Z",
    fill: "#B14F18"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M264.978 313.411L278.877 391.773H270.518L249.745 313.411H264.978Z",
    fill: "#D97C2F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M251.731 320.905L267.865 329.686L264.978 313.411H249.745L251.731 320.905Z",
    fill: "#B14F18"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M235.848 313.411L249.745 391.773H241.387L220.613 313.411H235.848Z",
    fill: "#D97C2F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M222.6 320.905L238.733 329.686L235.848 313.411H220.613L222.6 320.905Z",
    fill: "#B14F18"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M232.64 305.972H160.658L136.738 213.002C136.128 210.635 137.917 208.33 140.363 208.33H204.616C206.324 208.33 207.815 209.485 208.242 211.14L232.64 305.972Z",
    fill: "#D97C2F"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M151.542 270.545L227.198 284.825L232.64 305.972H160.656L151.542 270.545Z",
    fill: "#B14F18"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M270.566 313.411H153.87C153.87 301.485 163.545 291.815 175.478 291.815H248.958C260.892 291.815 270.566 301.485 270.566 313.411Z",
    fill: "#D97C2F"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M884.589 312.469L898.487 390.831H890.129L869.355 312.469H884.589Z",
    fill: "#D97C2F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M871.341 319.963L887.476 328.744L884.589 312.469H869.355L871.341 319.963Z",
    fill: "#B14F18"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M855.458 312.469L869.355 390.831H860.997L840.223 312.469H855.458Z",
    fill: "#D97C2F"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M842.21 319.963L858.344 328.744L855.458 312.469H840.223L842.21 319.963Z",
    fill: "#B14F18"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M779.021 312.469L765.122 390.831H773.482L794.254 312.469H779.021Z",
    fill: "#D97C2F"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M792.268 319.963L776.133 328.744L779.02 312.469H794.254L792.268 319.963Z",
    fill: "#B14F18"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M808.15 312.469L794.253 390.831H802.612L823.385 312.469H808.15Z",
    fill: "#D97C2F"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M821.398 319.963L805.265 328.744L808.151 312.469H823.386L821.398 319.963Z",
    fill: "#B14F18"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M811.359 305.03H883.341L907.261 212.06C907.87 209.692 906.081 207.386 903.635 207.386H839.382C837.675 207.386 836.183 208.542 835.757 210.196L811.359 305.03Z",
    fill: "#D97C2F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M892.457 269.602L816.8 283.883L811.359 305.03H883.342L892.457 269.602Z",
    fill: "#B14F18"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M773.433 312.469H890.129C890.129 300.541 880.454 290.873 868.521 290.873H795.041C783.106 290.873 773.433 300.542 773.433 312.469Z",
    fill: "#D97C2F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M780.144 349.533L780.126 371.23C780.125 372.777 780.384 374.306 780.909 375.761C782.223 379.407 784.702 387.604 784.405 396.935L734.373 396.893C734.373 396.893 737.3 390.272 750.55 386.208C752.905 385.486 755.065 384.239 756.942 382.643L761.822 378.49C764.522 376.195 765.796 372.638 765.17 369.15L761.643 349.515L780.144 349.533Z",
    fill: "#E9BCA0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M782.05 379.296L769.919 385.072L760.974 379.21L756.942 382.642C755.065 384.238 752.905 385.484 750.55 386.206C737.299 390.269 734.373 396.892 734.373 396.892L784.405 396.933C784.627 389.936 783.289 383.578 782.05 379.296Z",
    fill: "#1B2536"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M820.533 349.567L824.875 373.91C825.091 375.125 825.11 376.366 824.928 377.588L822.056 396.967L860.361 397C860.361 397 859.845 391.27 858.022 389.705C856.199 388.141 850.991 384.23 850.991 384.23L843.173 376.113C841.412 374.285 840.356 371.894 840.191 369.362L838.902 349.582L820.533 349.567Z",
    fill: "#E9BCA0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M843.471 376.42C834.897 376.851 830.213 383.072 830.213 383.072L824.557 380.105L822.059 396.966L860.364 396.998C860.364 396.998 859.848 391.269 858.025 389.704C856.202 388.139 850.994 384.229 850.994 384.229L843.471 376.42Z",
    fill: "#1B2536"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M761.08 91.1008L777.51 73.5347L797.445 73.4208L808.57 91.1408L799.108 149.875L762.006 149.842L761.08 91.1008Z",
    fill: "#FF876F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M773.846 92.9984L785.257 83.5033L798.793 96.7965",
    stroke: "white",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M785.253 87.9949L777.939 144.243",
    stroke: "white",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M818.462 179.761L849.196 352.325L814.018 352.296L777.895 197.567L788.609 354.227L753.04 354.198L743.167 172.341L759.368 150.144L810.409 151.488L818.462 179.761Z",
    fill: "#324B85"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M818.462 179.761L810.407 151.488L759.368 150.144L743.167 172.341L743.412 176.867C754.484 177.096 790.961 178.763 820.387 190.565L818.462 179.761Z",
    fill: "#28364F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M777.895 197.567L774.141 182.69L776.792 153.683",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M762.758 185.639L796.245 185.668",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M772.495 153.679L774.411 179.724",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M754.763 164.863L763.985 354.207",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M799.097 164.9L833.17 352.312",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M807.332 147.568H758.422V155.364H807.332V147.568Z",
    fill: "#1B2536"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M784.097 26.5646C792.118 27.9844 798.377 33.0752 801.477 41.4241C803.037 45.6245 803.327 49.9225 807.039 52.5625C810.75 55.2025 811.333 59.0124 811.037 61.1599C810.743 63.3089 811.521 66.5317 813.865 68.2917L759.437 68.2458C759.437 68.2458 762.471 63.658 761.888 59.7519C761.305 55.8444 759.45 53.2059 760.822 49.2037C762.194 45.2015 764.048 43.4015 761.416 40.0235C757.608 35.1369 763.579 22.9336 784.097 26.5646Z",
    fill: "#142216"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M782.362 35.4504C782.361 37.1439 783.786 46.781 791.599 50.5629L792.181 55.9671L797.443 73.4208L785.124 82.4605L777.508 73.5347L777.514 65.6561C772.433 66.1072 768.2 63.1684 767.879 57.699C767.558 52.2297 767.823 47.4836 766.262 44.5522C766.265 44.5522 774.213 44.428 782.362 35.4504Z",
    fill: "#E9BCA0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M786.651 55.2839C786.651 56.8294 785.398 58.0836 783.85 58.0836C782.303 58.0836 781.048 56.8309 781.048 55.2839C781.048 53.7383 782.302 52.4841 783.85 52.4841C785.398 52.4856 786.651 53.7383 786.651 55.2839Z",
    fill: "#D65353"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M778.348 65.5274C778.348 65.5274 783.82 65.483 787.391 60.799",
    stroke: "#422424",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M797.014 51.922C795.649 55.0146 792.606 56.6667 790.221 55.6136C787.834 54.5606 787.008 51.2003 788.374 48.1077C789.74 45.0166 792.782 43.3631 795.168 44.4161C797.553 45.4691 798.38 48.8294 797.014 51.922Z",
    fill: "#E9BCA0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M789.841 52.0596C789.841 52.0596 790.725 47.3727 794.781 46.4483",
    stroke: "#422424",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M793.312 50.304L792.696 47.4022",
    stroke: "#422424",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M796.662 54.9954C796.661 56.0381 795.814 56.8826 794.771 56.8826C793.728 56.8812 792.883 56.0352 792.883 54.9925C792.884 53.9498 793.731 53.1053 794.774 53.1053C795.819 53.1067 796.664 53.9527 796.662 54.9954Z",
    stroke: "white",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M771.684 51.5804L772.315 50.6693C772.001 50.3425 771.555 50.1502 771.073 50.2271C770.292 50.3513 769.759 51.0849 769.883 51.8658C770.008 52.6468 770.742 53.1807 771.523 53.0564C772.304 52.9322 772.838 52.1986 772.714 51.4177C772.705 51.36 772.671 51.3156 772.655 51.2594L771.684 51.5804Z",
    fill: "#1B2536"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M780.53 50.1768L781.161 49.2658C780.847 48.9389 780.402 48.7466 779.919 48.8236C779.138 48.9478 778.604 49.6814 778.728 50.4623C778.852 51.2432 779.586 51.7771 780.368 51.6529C781.149 51.5287 781.683 50.7951 781.559 50.0142C781.55 49.9565 781.516 49.9121 781.5 49.8574L780.53 50.1768Z",
    fill: "#1B2536"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M774.923 51.2979C774.923 51.2979 774.955 52.8287 774.92 54.0977C774.886 55.3667 776.384 56.0514 778.015 54.9792",
    stroke: "#422424",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M775.406 57.4506C776.838 57.875 780.388 58.0732 782.639 54.9821",
    stroke: "#422424",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M781.575 54.3639L783.225 55.3746",
    stroke: "#422424",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M777.208 46.0256C777.208 46.0256 780.76 44.8566 783.234 45.7371",
    stroke: "#732727",
    strokeWidth: 0.9712,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M769.031 47.7443C769.031 47.7443 771.313 46.411 773.787 47.2279",
    stroke: "#732727",
    strokeWidth: 0.9712,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M797.445 73.4208L785.464 146.839C784.946 150.014 785.194 153.268 786.187 156.329L790.928 170.943C791.724 173.395 794.576 174.491 796.81 173.205L820.237 159.71L810.087 144.271L823.533 96.8956C825.435 90.1972 821.956 83.1468 815.48 80.5777L797.445 73.4208Z",
    fill: "#324B85"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M804.942 144.982L792.556 155.371",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M799.21 76.1289L800.338 77.8593C803.861 83.2636 804.104 90.1735 800.968 95.8114L798.79 99.7264L801.221 106.919C802.285 110.066 802.037 113.509 800.533 116.472L787.321 142.493",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M810.089 144.269L794.403 173.709C795.208 173.787 796.044 173.644 796.812 173.203L820.239 159.709L810.089 144.269Z",
    fill: "#1B2536"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M810.445 107.874L812.088 137.224L818.056 116.195L810.445 107.874Z",
    fill: "#1B2536"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M798.729 172.098L814.728 175.664L804.924 164.905L798.729 172.098Z",
    fill: "#E9BCA0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M777.51 73.5347L767.937 167.672C767.666 170.334 765.422 172.359 762.745 172.357L739.122 172.338C739.122 172.338 748.522 149.656 756.155 137.178L755.965 130.357L744.864 142.044C740.483 146.654 733.348 147.264 728.247 143.465C722.946 139.515 721.616 132.134 725.206 126.585L749.188 89.5109C751.9 85.3164 755.859 82.076 760.507 80.242L777.51 73.5347Z",
    fill: "#324B85"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M776.239 74.999C773.5 79.0988 766.166 85.2455 771.822 98.0433C765.95 108.39 764.766 122.348 769.051 139.446",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M743.974 135.295L746.126 116.09",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M784.063 133.295L746.867 133.264L728.617 80.7996L765.814 80.8307L784.063 133.295Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M808.232 106.441L825.273 136.536L804.924 164.906L818.462 179.763L846.817 153.464C853.022 147.71 854.618 138.524 850.719 131.015L831.773 94.5262C828.616 88.4475 823.373 83.7102 817.004 81.1826L810.104 78.445L808.232 106.441Z",
    fill: "#324B85"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M825.273 136.534L829.905 130.419",
    stroke: "#1B2536",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M730.527 109.679C730.606 109.306 733.12 106.262 735.418 104.653C736.756 103.715 738.276 102.894 739.312 102.372C740.04 102.006 740.92 102.164 741.481 102.755L743.346 104.719C743.915 105.32 744.017 106.225 743.596 106.938L739.27 114.226C739.27 114.226 745.673 110.813 746.113 111.107C746.373 111.282 743.93 114.016 741.9 116.211C740.208 118.041 737.491 118.542 735.292 117.368C732.615 115.941 729.725 113.475 730.527 109.679Z",
    fill: "#E9BCA0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M734.338 108.949L741.832 103.127",
    stroke: "#422424",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M737.022 112.273L743.222 104.745",
    stroke: "#422424",
    strokeWidth: 0.4636,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M270.816 73.4978L288.28 132.582C290.439 139.886 289.351 147.763 285.295 154.208L272.043 175.266L258.889 131.315L254.452 58.5199L257.387 59.5182C263.868 61.7219 268.876 66.9339 270.816 73.4978Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M275.749 169.377L264.779 128.96L266.217 96.767L275.749 169.377Z",
    fill: "#1B2536"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M320.534 359.118L322.63 364.747C324.096 368.687 327.293 371.736 331.3 373.012L344.925 377.354C349.506 378.814 353.379 381.926 355.791 386.083L359.896 393.162H301.47C299.689 393.162 298.428 391.423 298.985 389.732L303.199 376.908C304.005 374.458 304.046 371.824 303.319 369.351L300.312 359.12H320.534V359.118Z",
    fill: "#DAB6A5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M359.898 393.162L355.793 386.083C353.38 381.926 349.508 378.814 344.926 377.354L331.301 373.012C330.298 372.693 329.345 372.261 328.459 371.733L327.152 374.343C325.271 378.103 321.119 380.154 316.987 379.364L303.244 376.736C303.226 376.792 303.22 376.85 303.202 376.906L298.988 389.731C298.431 391.421 299.692 393.16 301.472 393.16H359.898V393.162Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M226.954 359.118V371.734L232.32 393.848H203.087L207.583 371.734L206.797 359.118H226.954Z",
    fill: "#DAB6A5"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M217.454 371.734C211.71 371.734 206.76 375.776 205.616 381.402L203.086 393.848H232.317L229.19 380.96C227.879 375.546 223.028 371.734 217.454 371.734Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M270.263 162.446L326.424 364.416H298.344L231.666 202.736V364.416H201.723L185.333 162.446L240.042 136.219L270.263 162.446Z",
    fill: "#263238"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M270.263 162.446L240.042 136.219L185.333 162.446L186.166 172.696L276.746 185.761L270.263 162.446Z",
    fill: "#1B2536"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M231.666 202.736L233.572 137.497",
    stroke: "black",
    strokeWidth: 0.3698,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M243.183 143.872L241.835 167.82C241.569 172.55 239.262 176.93 235.512 179.826L232.261 182.338",
    stroke: "black",
    strokeWidth: 0.3698,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M216.875 183.507L252.213 188.609",
    stroke: "black",
    strokeWidth: 0.3698,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M203.087 356.023H228.555",
    stroke: "black",
    strokeWidth: 0.3698,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M297.302 356.023H322.769",
    stroke: "black",
    strokeWidth: 0.3698,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M240.068 186.856L304.435 356.023",
    stroke: "black",
    strokeWidth: 0.3698,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M196.85 163.105L210.201 356.023",
    stroke: "black",
    strokeWidth: 0.3698,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M232.774 160.049L239.519 144.657L242.149 159.255C243.802 168.433 251.441 175.343 260.743 176.074L277.933 177.424L264.778 128.96L267.214 74.4355C267.516 67.6779 263.318 61.5341 256.912 59.3556L234.546 51.7505H213.931L193.017 57.1681C182.344 59.9324 173.082 66.5657 167.034 75.7784L141.615 114.491C135.426 123.917 135.215 136.06 141.071 145.694C144.029 150.561 150.385 152.104 155.243 149.13L172.376 138.64L194.692 114.587L180.557 169.772L212.361 172.271C221.075 172.956 229.267 168.05 232.774 160.049Z",
    fill: "#263238"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M268.116 129.941H281.073",
    stroke: "black",
    strokeWidth: 0.4321,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M270.263 132.099L281.073 136.219",
    stroke: "black",
    strokeWidth: 0.4321,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M267.102 76.9527L264.779 128.96L274.595 165.128",
    stroke: "black",
    strokeWidth: 0.3698,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M236.508 124.251L240.563 138.013C240.989 139.458 240.926 141.004 240.384 142.41L239.518 144.657",
    stroke: "#1B2536",
    strokeWidth: 0.4321,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M234.544 140.915C235.629 140.915 236.508 140.036 236.508 138.952C236.508 137.869 235.629 136.99 234.544 136.99C233.46 136.99 232.581 137.869 232.581 138.952C232.581 140.036 233.46 140.915 234.544 140.915Z",
    stroke: "white",
    strokeWidth: 0.4321,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M181.145 71.6653L191.262 101.294",
    stroke: "black",
    strokeWidth: 0.4277,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M204.647 85.1236L162.326 96.6119L177.146 151.144L219.467 139.656L204.647 85.1236Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M177.143 151.172L213.544 117.889L210.581 106.982L168.807 122.451L177.143 151.172Z",
    fill: "#1B2536"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M188.921 112.9L197.38 106.709L202.037 104.941C203.004 104.575 204.116 105.162 204.535 106.264L204.808 106.982L210.68 105.259C211.885 104.906 213.181 105.781 213.516 107.172L214.445 111.041C214.683 112.033 214.364 113.043 213.64 113.589L212.194 114.679L212.239 114.846C212.598 116.208 212.122 117.606 211.072 118.276L204.477 122.481C203.274 123.248 201.954 123.787 200.567 124.078L193.26 125.612L188.921 112.9Z",
    fill: "#DAB6A5"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M201.881 112.01L213.544 107.287",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M203.824 115.722L214.238 110.177",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M205.346 118.952L212.196 114.679",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M204.81 106.982L198.724 109.455",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M185.333 113L190.271 111.252L196.458 127.783L188.474 132.099L185.333 113Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M211.661 54.5296L204.062 63.6787C201.89 66.2936 202.023 70.1198 204.37 72.5764L219.099 88.0009L213.869 94.7422C211.894 97.2891 212.014 100.883 214.156 103.292L238.344 130.491L249.955 99.3227C250.967 96.6072 250.115 93.5487 247.845 91.7458L241.217 86.4805L248.551 69.963C249.782 67.1884 248.992 63.9316 246.625 62.0296L237.291 54.5296",
    stroke: "#1B2536",
    strokeWidth: 0.4321,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M148.365 124.619L185.332 113.002L192.4 131.839L166.596 150.329C158.062 156.445 146.127 154.009 140.673 145.042C135.998 137.352 139.777 127.317 148.365 124.619Z",
    fill: "#263238"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M149.536 124.251L183.813 113.478",
    stroke: "black",
    strokeWidth: 0.4321,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M213.93 51.7491L236.508 124.251L234.544 51.7491H213.93Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M226.692 58.5199L218.46 66.2936L219.346 69.1406L227.019 61.2013L234.92 65.6339L234.846 62.8844L226.692 58.5199Z",
    fill: "#DDE9EB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M237.489 19.0809C242.986 15.2547 245.637 5.44446 237.489 1.81351C229.341 -1.81596 218.739 3.97136 213.439 8.28857C206.568 5.73729 199.206 18.0988 207.746 20.5525L209.905 30.1068L237.489 19.0809Z",
    fill: "#1B2536"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M214.716 27.8114C214.716 27.8114 219.919 25.0649 219.625 15.058H238.374L239.355 26.4389C243.478 29.8731 243.478 40.8607 233.465 42.5275L234.546 51.7491L226.692 58.5185L213.932 51.7491L213.44 33.4035L214.716 27.8114Z",
    fill: "#E9BCA0"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M227.422 30.5978C227.422 32.1182 226.189 33.3517 224.668 33.3517C223.146 33.3517 221.914 32.1197 221.914 30.5978C221.914 29.0774 223.146 27.8454 224.668 27.8454C226.189 27.8454 227.422 29.0774 227.422 30.5978Z",
    fill: "#CF5A42"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M226.055 21.6307C225.051 21.6307 224.239 22.4426 224.239 23.4454C224.239 23.6258 224.273 23.7959 224.322 23.9601L225.698 23.5844L224.863 24.8046C225.183 25.0841 225.596 25.2601 226.055 25.2601C227.058 25.2601 227.87 24.4481 227.87 23.4454C227.87 22.4441 227.056 21.6307 226.055 21.6307Z",
    fill: "#1B2536"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M235.117 21.6307C234.113 21.6307 233.301 22.4426 233.301 23.4454C233.301 23.6258 233.335 23.7959 233.384 23.9601L234.76 23.5844L233.925 24.8046C234.245 25.0841 234.658 25.2601 235.117 25.2601C236.12 25.2601 236.932 24.4481 236.932 23.4454C236.932 22.4441 236.12 21.6307 235.117 21.6307Z",
    fill: "#1B2536"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M232.327 19.6357C232.327 19.6357 234.239 18.6546 237.282 19.4729",
    stroke: "#1B2536",
    strokeWidth: 0.8641,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M228.23 19.6357C228.23 19.6357 226.318 18.6546 223.275 19.4729",
    stroke: "#1B2536",
    strokeWidth: 0.8641,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M226.055 30.7546H236.476C236.476 30.7546 235.773 27.8439 231.265 27.8439C226.758 27.8439 226.055 30.7546 226.055 30.7546Z",
    fill: "#1B2536"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M231.175 20.977L231.398 24.182L233.28 26.8767C233.566 27.2849 233.273 27.844 232.776 27.844H229.899",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M234.3 34.2377C234.3 34.2377 232.435 35.0235 229.686 34.2377",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M232.327 42.6917C232.327 42.6917 222.699 44.6543 216.941 38.5061",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M215.788 30.0468C215.788 31.9199 214.268 33.4387 212.394 33.4387C210.52 33.4387 209 31.9199 209 30.0468C209 28.1737 210.52 26.6549 212.394 26.6549C214.269 26.6549 215.788 28.1737 215.788 30.0468Z",
    fill: "#D7B098"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M210.496 29.5395C211.511 27.8838 213.596 27.8838 214.825 30.6081",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M212.394 30.6081L212.863 28.5014",
    stroke: "#422424",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M231.796 61.2176L226.692 58.5199L222.521 62.4925L226.448 66.5317L225.382 88.5244L236.508 124.251L235.544 88.6649L229.917 66.2699L231.796 61.2176Z",
    fill: "#D65353"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M655.295 128.725H660.21L678.908 187.51H673.994H602.156L583.458 128.725H655.295Z",
    fill: "#142216"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M622.098 165.996H640.365C644.177 165.996 646.284 162.908 645.072 159.098L644.448 157.137C643.236 153.327 639.163 150.239 635.353 150.239H617.086C613.274 150.239 611.167 153.327 612.379 157.137L613.002 159.098C614.215 162.908 618.286 165.996 622.098 165.996Z",
    stroke: "#6E9296",
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M658.042 131.831L674.74 184.328",
    stroke: "#6E9296",
    strokeWidth: 0.3975,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M619.082 187.51H732.623V184.329H619.082V187.51Z",
    fill: "#142216"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M359.899 353.508V393.162H532.551C543.504 393.162 552.388 384.285 552.388 373.336C552.388 367.862 550.167 362.903 546.577 359.318C542.986 355.73 538.028 353.51 532.551 353.51H359.899V353.508Z",
    fill: "#BD4A2C"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M359.899 353.508V393.162H514.307C525.264 393.162 534.144 384.285 534.144 373.336C534.144 367.862 531.923 362.903 528.333 359.318C524.743 355.73 519.787 353.51 514.307 353.51H359.899V353.508Z",
    fill: "#8A2C08"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M360.11 386.965H514.573C522.105 386.965 528.211 380.863 528.211 373.334C528.211 365.806 522.105 359.704 514.573 359.704H360.11C359.994 359.704 359.901 359.797 359.901 359.913V386.758C359.901 386.872 359.994 386.965 360.11 386.965Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M514.795 366.967L359.902 366.778L359.905 364.746L514.798 364.937C515.358 364.937 515.813 365.392 515.813 365.953C515.813 366.513 515.357 366.967 514.795 366.967Z",
    fill: "#DFCAB8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M514.795 373.783L359.902 373.593L359.905 371.561L514.798 371.752C515.358 371.752 515.813 372.207 515.813 372.768C515.813 373.329 515.357 373.783 514.795 373.783Z",
    fill: "#DFCAB8"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M514.795 380.908L359.902 380.719L359.905 378.687L514.798 378.876C515.358 378.876 515.813 379.332 515.813 379.892C515.813 380.453 515.357 380.908 514.795 380.908Z",
    fill: "#DFCAB8"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M380.905 314.18V353.834H553.557C564.509 353.834 573.394 344.957 573.394 334.008C573.394 328.534 571.173 323.575 567.583 319.99C563.993 316.402 559.034 314.182 553.557 314.182H380.905V314.18Z",
    fill: "#835F26"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M380.905 314.18V353.834H535.314C546.27 353.834 555.151 344.957 555.151 334.008C555.151 328.534 552.93 323.575 549.34 319.99C545.749 316.402 540.794 314.182 535.314 314.182H380.905V314.18Z",
    fill: "#5A3B08"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M380.907 347.638H535.579C543.111 347.638 549.217 341.536 549.217 334.008C549.217 326.48 543.111 320.377 535.579 320.377H380.907V347.638Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M535.799 334.454L380.907 334.265L380.91 332.233L535.802 332.422C536.363 332.422 536.817 332.878 536.817 333.438C536.817 334 536.361 334.456 535.799 334.454Z",
    fill: "#DFCAB8"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M535.799 341.58L380.907 341.391L380.91 339.359L535.802 339.548C536.363 339.55 536.817 340.004 536.817 340.564C536.817 341.125 536.361 341.58 535.799 341.58Z",
    fill: "#DFCAB8"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M535.799 327.639L380.907 327.45L380.91 325.418L535.802 325.609C536.363 325.609 536.817 326.064 536.817 326.625C536.817 327.185 536.361 327.641 535.799 327.639Z",
    fill: "#DFCAB8"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M367.668 274.873V314.526H540.32C551.274 314.526 560.157 305.649 560.157 294.7C560.157 289.227 557.936 284.267 554.346 280.682C550.756 277.094 545.797 274.874 540.32 274.874H367.668V274.873Z",
    fill: "#324B85"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M367.668 274.873V314.526H522.077C533.034 314.526 541.914 305.649 541.914 294.7C541.914 289.227 539.693 284.267 536.103 280.682C532.513 277.094 527.557 274.874 522.077 274.874H367.668V274.873Z",
    fill: "#13244A"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M367.67 308.331H522.342C529.874 308.331 535.98 302.228 535.98 294.7C535.98 287.172 529.874 281.07 522.342 281.07H367.67V308.331Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M522.564 288.333L367.671 288.144L367.674 286.112L522.567 286.301C523.128 286.301 523.582 286.757 523.582 287.317C523.582 287.878 523.126 288.333 522.564 288.333Z",
    fill: "#DFCAB8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M522.564 295.147L367.671 294.958L367.674 292.925L522.567 293.115C523.128 293.116 523.582 293.57 523.582 294.131C523.582 294.693 523.126 295.148 522.564 295.147Z",
    fill: "#DFCAB8"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M522.564 302.273L367.671 302.083L367.674 300.051L522.567 300.241C523.128 300.242 523.582 300.696 523.582 301.257C523.582 301.819 523.126 302.274 522.564 302.273Z",
    fill: "#DFCAB8"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M404.248 286.193V305.642L398.147 299.544L391.837 305.851V286.11L404.248 286.193Z",
    fill: "#BD4A2C"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.967 357.904C614.015 351.512 625.724 329.958 628.469 312.567L641.63 325.2C638.885 342.592 626.416 364.205 611.368 370.597L609.848 360.442L598.967 357.904Z",
    fill: "#1B2536"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.282 341.854C598.363 339.973 611.248 328.643 620.011 314.336L628.117 330.676C619.772 345.02 606.182 355.339 589.651 357.994L591.661 347.924L582.282 341.854Z",
    fill: "#BD4A2C"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.099 346.017C666.484 353.395 661.874 357.724 655.259 365.101C665.389 374.175 667.956 378.212 678.086 387.286C692.85 392.894 704.551 376.399 697.93 365.156C687.802 356.083 683.228 355.091 673.099 346.017Z",
    fill: "#CBCBCB"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.968 386.221C669.263 376.335 681.152 364.914 690.184 370.369L654.943 341.546L643.618 354.175L675.968 386.221Z",
    fill: "#E5E5E5"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.844 290.169C542.028 282.525 572.827 248.789 581.629 259.185C616.179 299.998 655.31 333.656 696.741 362.893C679.498 349.737 653.855 377.294 669.333 393.62C634.385 355.178 597.484 318.398 553.844 290.169Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M669.333 393.62C665.784 390.441 664.116 385.842 664.288 380.978C664.46 376.133 666.459 371.026 670.246 366.802C674.033 362.579 678.895 360.035 683.694 359.337C688.514 358.635 693.27 359.791 696.82 362.971C699.517 365.386 700.785 368.88 700.653 372.574C700.523 376.248 699.006 380.122 696.137 383.324C693.266 386.524 689.578 388.453 685.939 388.982C682.278 389.515 678.666 388.636 675.97 386.221C674.126 384.57 673.26 382.182 673.349 379.659C673.438 377.155 674.471 374.515 676.424 372.336C678.377 370.156 680.89 368.843 683.372 368.482C685.874 368.119 688.343 368.718 690.185 370.369",
    stroke: "#1B2536",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.387 332.718C604.175 322.776 621.799 306.556 628.892 308.393C632.533 309.335 643.619 319.414 641.434 319.636C633.882 320.785 620.812 335.402 620.272 343.117C620.206 345.254 609.046 337.852 607.387 332.718Z",
    fill: "#BD4A2C"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M612.763 335.51L652.316 373.988",
    stroke: "#1B2536",
    strokeWidth: 0.4321,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M321.047 141.03C320.457 141.03 319.978 140.553 319.978 139.961V123.87C319.978 123.278 320.457 122.8 321.047 122.8C321.638 122.8 322.117 123.278 322.117 123.87V139.961C322.117 140.553 321.638 141.03 321.047 141.03Z",
    fill: "#B34F18"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M329.098 132.985H312.997C312.407 132.985 311.927 132.507 311.927 131.915C311.927 131.324 312.407 130.846 312.997 130.846H329.098C329.688 130.846 330.168 131.324 330.168 131.915C330.168 132.507 329.688 132.985 329.098 132.985Z",
    fill: "#B34F18"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6472 151.73C85.9694 151.73 85.4189 151.181 85.4189 150.502V132.031C85.4189 131.352 85.9694 130.803 86.6472 130.803C87.325 130.803 87.8755 131.352 87.8755 132.031V150.502C87.8755 151.181 87.325 151.73 86.6472 151.73Z",
    fill: "#B34F18"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8871 142.495H77.4055C76.7277 142.495 76.1772 141.946 76.1772 141.267C76.1772 140.588 76.7277 140.04 77.4055 140.04H95.8871C96.5649 140.04 97.1154 140.588 97.1154 141.267C97.1154 141.946 96.5649 142.495 95.8871 142.495Z",
    fill: "#B34F18"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M860.363 172.22C859.772 172.22 859.293 171.742 859.293 171.15V155.06C859.293 154.469 859.772 153.991 860.363 153.991C860.953 153.991 861.433 154.469 861.433 155.06V171.15C861.433 171.742 860.953 172.22 860.363 172.22Z",
    fill: "#B34F18"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M868.413 164.174H852.313C851.722 164.174 851.243 163.696 851.243 163.105C851.243 162.513 851.722 162.035 852.313 162.035H868.413C869.004 162.035 869.483 162.513 869.483 163.105C869.483 163.696 869.004 164.174 868.413 164.174Z",
    fill: "#B34F18"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M903.08 92.6184C902.489 92.6184 902.01 92.1407 902.01 91.5491V75.459C902.01 74.8674 902.489 74.3896 903.08 74.3896C903.67 74.3896 904.15 74.8674 904.15 75.459V91.5491C904.15 92.1392 903.67 92.6184 903.08 92.6184Z",
    fill: "#B34F18"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M911.129 84.5726H895.028C894.438 84.5726 893.958 84.0949 893.958 83.5033C893.958 82.9117 894.438 82.434 895.028 82.434H911.129C911.719 82.434 912.198 82.9117 912.198 83.5033C912.198 84.0949 911.719 84.5726 911.129 84.5726Z",
    fill: "#B34F18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroimg);
export default __webpack_public_path__ + "static/media/heroimg.9d5ad75016bc2b145cbfea51002c0ba5.svg";
export { ForwardRef as ReactComponent };